import React from 'react';
import { Fade } from 'react-awesome-reveal';

const Description = () => {
    return (
        <Fade>
            <div className='center_wrapper'>
                <h2>Highlights</h2>
                <div className='highlight_description'>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Quaerat maiores facilis ullam tenetur soluta quo eaque,
                    omnis sint quas quia nisi magni perspiciatis aut natus iure,
                    architecto dolores, rerum eos? Lorem ipsum dolor sit amet
                    consectetur, adipisicing elit. Expedita earum deserunt
                    quidem ab quo porro veritatis consequuntur nam amet ut!
                    Officia, accusamus quae! Ipsam minima eaque ex enim,
                    architecto exercitationem!
                </div>
            </div>
        </Fade>
    );
};

export default Description;
